module.exports = "mutation UpdateHotlineAnswer($data:HotlineAnswerInput!){updateHotlineAnswer(data:$data){success}}"